<template>
  <div class="main">
    <div class="mian-top">
      <div @click="back">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>
    </div>
    <div class="mian-bottom">
      <div class="tablebox" v-loading="isLoadingShow">
        <el-table :data="orderList" style="width: 100%; " :header-cell-style="{background:' rgba(59,196,146,0.1)',height:'56px',fontSize:'14px',fontWeight:'550',color:'rgba(0,0,0,0.7)'}">
          <el-table-column prop="seq" label="ID" align='center' width="80">
            <template slot-scope="scope">
              {{scope.$index+1}}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="orderNo" label="订单编号" align='center' width="250"></el-table-column> -->
          <el-table-column prop="createdBy" label="购买人" align='center'></el-table-column>
          <el-table-column prop="payTime" label="购买时间" align='center'>
            <template slot-scope="scope">
              {{
                  $moment(scope.row.payTime).format('YYYY/MM/DD HH:mm:ss')
                }}</template>
          </el-table-column>
          <el-table-column prop="content" label="套餐类型" align='center'></el-table-column>
          <el-table-column prop="payment" label="购买数量" align='center'>
            <template slot-scope="scope">
             <span >{{scope.row.upgrade?scope.row.orderNum +'(月)':scope.row.effectiveMouth}}</span>

            </template>
          </el-table-column>

          <el-table-column prop="createdTime" label="有效期" align='center' width="210">
            <template slot-scope="scope">{{
                  $moment(scope.row.beginTime).format('YYYY/MM/DD')
                }}至{{
                  $moment(scope.row.expireTime).format('YYYY/MM/DD')
                }}</template>
          </el-table-column>

          <el-table-column prop="createdTime" label="总条数" align='center'>
            <template slot-scope="scope">
              {{
                  scope.row.buyNum
                }}条
            </template>
          </el-table-column>

          <el-table-column prop="payAmount" label="购买金额" align='center'>
            <template slot-scope="scope">￥{{
                  scope.row.balancePay
                    ? scope.row.balancePayment
                    : scope.row.payAmount
                }}元
            </template>
          </el-table-column>

          <!-- <el-table-column prop="state" label="订单状态" align='center'>
            <template slot-scope="scope">
              <div v-if="scope.row.state == 0">待支付</div>
              <div v-if="scope.row.state == 1">待审核</div>
              <div v-if="scope.row.state == 2" style="display: flex; align-items: center; color: red">
                审核不通过
                <el-tooltip :content="scope.row.failReason" placement="bottom" effect="light">
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </div>
              <div v-if="scope.row.state == 3">已关闭</div>
              <div v-if="scope.row.state == 4">已支付</div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column fixed="right" label="操作" align='center' width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.state == 0" class="flexaround">
                <el-button style="border: 1px solid #3BC492;color: #3BC492;" round size="small" @click="handleToPay(scope.row)">支付</el-button>
                <el-button round size="small" @click="handleToCancel(scope.row)">取消</el-button>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination v-if="totalCount" small :current-page="tableRequest.pageNum"
         :page-size="tableRequest.pageSize" :page-sizes="[5, 10, 20, 30]" 
         @current-change="handleCurrentChange" layout="prev, pager, next" :total="totalCount"></el-pagination>
      </div>
    </div>
  </div>
</template>


<script>
import Cookie from 'js-cookie'
import { customerOrder, rechargeOrder } from '@/api/setUp.js'
export default {
  name: 'index',
  components: {},
  data () {
    return {
      tableRequest: {
        pageNumber: 0,
        size: 10,
      },
      totalCount: 0,
      totalCount1: 0,
      activeName: 'frist',
      paramsData: {
        pageNumber: 0,
        size: 10,
      },
      userInfo: {},
      orderList: [],
      packageList: [],
      isLoadingShow: false,
    }
  },
  methods: {

    back () {
      this.$router.push('/index/provid')
    },
    handleCurrentChange (val) {
      this.tableRequest.pageNumber = val - 1
      this.getOrderList()
    },
    handleCurrentChange1 (val) {
      this.paramsData.pageNumber = val - 1
      this.getPackageList()
    },
    async getOrderList () {
      this.isLoadingShow = true
      const res = await customerOrder({
        pageNumber: this.tableRequest.pageNumber,
        size: this.tableRequest.size,
        app: 'salary',
        state: 4
      })
      if (res.status == 200) {
        this.orderList = res.data
        this.orderList.map((item) => {
          item.payAmount = item.payAmount.toFixed(2)
          item.balancePayment = item.balancePayment.toFixed(2)
        })
        this.totalCount = +res.headers['x-total-count']
        this.isLoadingShow = false
      }
    },
    async getPackageList () {
      let res = await rechargeOrder(this.paramsData)
      this.packageList = res.data
      this.totalCount1 = +res.headers['x-total-count']
    },
    async changOrderState (url, data = {}, msg = '') {
      let res = await this.$http.post(url, data)
      this.getPackageList()
      this.getOrderList()
      this.$notify({
        title: '成功',
        message: msg,
        type: 'success',
      })
    },
    handleToPay (val) {
      // if(val.orderId.includes('tc')){
      //   //套餐
      //   this.$http.get(`order/${val.orderId}`).then(res=>{
      //     if(res.data.state==0){

      //     }else{

      //     }
      //   })
      // }else{
      //   //充值
      // }
      switch (this.activeName) {
        case 'sec':
          this.$http
            .get(`/salary-service/customer/recharge_order/${val.id}`)
            .then((res) => {
              if (res.data.id) {
                this.$router.push({
                  name: 'chosePayment',
                  query: {
                    total: (+val.rechargeAmount).toFixed(2),
                    orderNum: val.orderNo,
                    type: 'recharge',
                  },
                })
              } else {
                this.getOrderList()
                this.getPackageList()
                this.$notify({
                  title: '失败',
                  message: '订单已过期',
                  type: 'warning',
                })
              }
            })
          break
        default:
          this.$http
            .get(`/salary-service/customer/order/${val.id}`)
            .then((res) => {
              if (res.data.id) {
                this.$router.push({
                  name: 'chosePayment',
                  query: {
                    total: (+val.payAmount).toFixed(2),
                    orderNum: val.orderNo,
                  },
                })
              } else {
                this.getOrderList()
                this.getPackageList()
                this.$notify({
                  title: '失败',
                  message: '订单已过期',
                  type: 'warning',
                })
              }
            })
          break
      }
    },
    handleToCancel (val) {
      switch (this.activeName) {
        case 'sec':
          this.changOrderState(
            '/salary-service/customer/recharge_order/cancel',
            {
              id: val.id,
              state: 3,
            },
            '充值订单取消成功'
          )
          break
        default:
          this.$http
            .get(`/salary-service/customer/${val.id}/cancel`)
            .then((res) => {
              this.getPackageList()
              this.getOrderList()
              this.$notify({
                title: '成功',
                message: '套餐订单取消成功',
                type: 'success',
              })
            })
          break
      }
    },
  },
  mounted () {
    this.getOrderList()
    this.getPackageList()
  },
}
</script>

<style lang="less" scoped>
.flexaround {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.main {
  padding: 10px;
  .mian-top {
    height: 57px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: left;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2c2d3a;
    line-height: 22px;
    padding-left: 14px;
    div {
      cursor: pointer;
    }
  }
  .mian-bottom {
    height: calc(100vh - 148px);
    background: #ffffff;
    border-radius: 8px;
    margin-top: 10px;
    overflow: auto;
    .tablebox {
      padding: 15px;
    }
  }
}
/deep/ .el-pagination {
    white-space: nowrap;
    padding: 2px 5px;
    color: #303133;
    font-weight: bold;
    text-align: center;
    line-height: 30px;
}
</style>
